export default __webpack_public_path__ + "static/media/info-item2.3a1de896.svg";